import EducationForm from "./EducationForm";
import { useInterviewContext } from "../InterviewContext";
import { useTranslation } from "react-i18next";
import WorkExperienceForm from "./WorkExperienceForm";
import "../../styles/forms.scss";

const EducationAndWorkTab = () => {
  const { interview, setInterview } = useInterviewContext();
  const { t } = useTranslation();

  const addNewEducationForm = () => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      interviewEducation: {
        ...prevInterview.interviewEducation,
        candidateCourses: [
          ...prevInterview.interviewEducation.candidateCourses,
          {}
        ]
      }
    }));
  };

  const onDeleteCourse = (index) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      interviewEducation: {
        ...prevInterview.interviewEducation,
        candidateCourses: prevInterview.interviewEducation.candidateCourses.filter(
          (candidateCourse, candidateCourseIndex) =>
            candidateCourseIndex !== index
        )
      }
    }));
  };

  const onChangeCourse = (event, index) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      interviewEducation: {
        ...prevInterview.interviewEducation,
        candidateCourses: prevInterview.interviewEducation.candidateCourses.map(
          (course, courseIndex) =>
            courseIndex === index
              ? { ...course, [`${event.target.name}`]: event.target.value }
              : { ...course }
        )
      }
    }));
  };

  const onChangeIsOngoing = (event, index) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      interviewEducation: {
        ...prevInterview.interviewEducation,
        candidateCourses: prevInterview.interviewEducation.candidateCourses.map(
          (course, courseIndex) =>
            courseIndex === index
              ? { ...course, isOngoing: !course.isOngoing }
              : { ...course }
        )
      }
    }));
  };

  const onChangeIsCertification = (event, index) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      interviewEducation: {
        ...prevInterview.interviewEducation,
        candidateCourses: prevInterview.interviewEducation.candidateCourses.map(
          (course, courseIndex) =>
            courseIndex === index
              ? { ...course, isCertification: !course.isCertification }
              : { ...course }
        )
      }
    }));
  };

  const onChangeFinalClassification = (event, index) => {
    let finalClassification = Number(event.target.value);
    if (finalClassification < 1000) {
      if (event.target.value === "") {
        finalClassification = null;
      }
      setInterview((prevInterview) => ({
        ...prevInterview,
        interviewEducation: {
          ...prevInterview.interviewEducation,
          candidateCourses: prevInterview.interviewEducation.candidateCourses.map(
            (course, courseIndex) =>
              courseIndex === index
                ? { ...course, [`${event.target.name}`]: finalClassification }
                : { ...course }
          )
        }
      }));
    }
  };

  const onChangeNotesOfFormation = ({ target }) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      interviewEducation: {
        ...prevInterview.interviewEducation,
        notesOfFormation: target.value
      }
    }));
  };

  const onChangeWork = ({ target }) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      candidateWorkExperience: {
        ...prevInterview.candidateWorkExperience,
        [`${target.name}`]: target.value
      }
    }));
  };

  const onSelectedCourse = (courseId, index) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      interviewEducation: {
        ...prevInterview.interviewEducation,
        candidateCourses: prevInterview.interviewEducation.candidateCourses.map(
          (course, courseIndex) =>
            courseIndex === index
              ? { ...course, courseId: courseId }
              : { ...course }
        )
      }
    }));
  };

  const onSelectedSchool = (schoolId, index) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      interviewEducation: {
        ...prevInterview.interviewEducation,
        candidateCourses: prevInterview.interviewEducation.candidateCourses.map(
          (course, courseIndex) =>
            courseIndex === index
              ? { ...course, schoolId: schoolId }
              : { ...course }
        )
      }
    }));
  };

  return (
    <section className="edu-work">
      <h1>{t("Education and Work")}</h1>
      <div>
        {interview.interviewEducation.candidateCourses.map((course, index) => {
          return (
            <EducationForm
              key={index}
              candidateCourse={course}
              index={index}
              onChangeCourse={onChangeCourse}
              onDelete={onDeleteCourse}
              onSelectedCourse={onSelectedCourse}
              onSelectedSchool={onSelectedSchool}
              onChangeIsOngoing={onChangeIsOngoing}
              onChangeIsCertification={onChangeIsCertification}
              onChangeFinalClassification={onChangeFinalClassification}
            />
          );
        })}
        <button
          className="app-button btn-prime btn-lg"
          style={{ float: "right" }}
          type="button"
          onClick={addNewEducationForm}
        >
          {t("Add another education experience")}
        </button>
      </div>
      <div className="form-group" style={{ marginTop: "80px", width: "100%" }}>
        <div className="label-wrapper">
          <label htmlFor="notes">{t("Notes")}</label>
        </div>
        <textarea
          id="NotesOfFormation"
          rows="4"
          name="NotesOfFormation"
          value={interview.interviewEducation.notesOfFormation}
          onChange={onChangeNotesOfFormation}
          placeholder={t("Describe the education experience...")}
        />
      </div>
      <div>
        <WorkExperienceForm
          onChange={onChangeWork}
          work={interview.candidateWorkExperience || {}}
        />
        <div>
          <div className="form-group">
            <div className="label-wrapper">
              <label htmlFor="personalProfile">{t("Personal Profile")}</label>
            </div>
            <textarea
              onChange={onChangeWork}
              value={interview.candidateWorkExperience?.personalProfile}
              name="personalProfile"
              placeholder={t("Describe their personal characteristics...")}
              rows={4}
            />
          </div>
          <div className="form-group">
            <div className="label-wrapper">
              <label htmlFor="remarks">{t("Comments")}</label>
            </div>
            <textarea
              onChange={onChangeWork}
              value={interview.candidateWorkExperience?.remarks}
              name="remarks"
              placeholder={t("Comments for the interview...")}
              rows={3}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationAndWorkTab;
